// export const BASE_URL = "http://192.168.1.32:8081/mtn-ftth-api/";
// export const BASE_URL = "http://192.168.1.31:8081/mtn-ftth-api/";
export const BASE_URL = "https://fibre.mtn.ci/mtn-ftth-api/";
// export const BASE_URL = "http://10.20.0.12:8080/mtn-ftth-api/";
// export const BASE_URL = "http://10.18.37.202:8082/mtn-ftth-api/";
// export const BASE_URL = "https://testmomoagent.mtn.ci/mtn-ftth-api/";

export const LOGIN_ENDPOINT = "/signin";
//////////////USER////////////////////////////////
export const USER_LIST = "/commerciale/user/rechercher-users";
export const ADD_USER = "/commerciale/user/enregistrer";
export const EDIT_USER = "/commerciale/user/modifier-utilisateur"
export const DISABLE_USER = "/commerciale/user/desactiver";
export const DELETE_USER = "/commerciale/user/supprimer";
export const EDIT_USER_CREDENTIALS = "/commerciale/user/modifieridentifiant"
export const FORGOT_PASSWORD = "/webfree/user/motdepasseoublie"
export const RESET_PASSWORD = "/webfree/user/renitialiserpassword"
export const EDIT_USER_PASSWORD = "/commerciale/user/modifiermotdepasse"
export const EDIT_PROFIL = "/commerciale/user/modifierprofile"
//////////////////////////////////////////////////////
export const APP_CLIENT = ' http://localhost:3001/#/login'

///////////IDENTIFICATION/////////////////////////////
export const IDENTIFICATION = "/commerciale/abonnement/rechercheridentification";
export const LIST_IDENTIFICATION = "/commerciale/identification/rechercher-identifications";
///////////////////////////////////////////////////////


///////////AGENT////////////////////////////////////////
export const AGENT_LIST = "/commerciale/agent/rechercheragents";
export const ADD_AGENT = "/commerciale/agent/enregistrer";
export const EDIT_AGENT = ""
export const EXPORT_EXCEL_VENTE_ATTENTE_SUPPRESSION = "/commerciale/abonnement/export-to-excel-vente-attente-validation-suppression";
export const SUPPRIMER_VENTE_PAR_LOT = "/commerciale/abonnement/supprimer-vente-par-lot";
export const DISABLE_AGENT = "/commerciale/agent/desactiver";
export const DELETE_AGENT = "/commerciale/agent/supprimer";
export const AGENT_BY_PROFIL = "/commerciale/agent/rechercherlistagent";
export const COORDINATEUR_LIST = "/commercial/user/liste-coordinateurs-techniciens";
export const COORDINATEUR_NON_ASSIGNE = "/commercial/coordinateur-prestataire/v3/liste-coordinateurs-non-associes"
export const COORDINATEURS_PRESTATAIRE = "/commercial/coordinateur-prestataire/v3/prestataire";
export const DISSOCIER_COORDINATEUR = "/commercial/coordinateur-prestataire/v3/dissocier";
///////////////////////////////////////////////////////////


///////////////CRENEAU//////////////////////////////////
export const LIST_CRENEAU = "/commerciale/crenau/recherchercrenaux";
export const ADD_CRENEAU = "/commerciale/crenau/enregistrer";
export const UPDATE_CRENEAU = "/commerciale/crenau/modifier";
export const DELETE_CRENEAU = "/commerciale/crenau/supprimer";
export const DISABLE_CRENEAU = "/commerciale/crenau/desactiver";
export const CRENEAU_DISPO = "/commerciale/creneau/recherchercreneauxdispo";
export const CRENEAUX = "/commerciale/creneau/rechercher-liste-creneaux"
/////////////////////////////////////////////////////////


//////////////////////BATIMENT//////////////////////////////////
export const LIST_BATIMENT = "/commerciale/batiment/rechercherbatiments";
export const UPDATE_BATIMENT = "/commerciale/batiment/modifier";
export const ADD_BATIMENT = "/commerciale/batiment/enregistrer";
export const DELETE_BATIMENT = "/commerciale/batiment/supprimer";
/////////////////////////////////////////////////////////////////


//////////////////////EQUIPEMENT//////////////////////////////////
export const LIST_EQUIP = "/commerciale/equipement/rechercherequipements";
export const EQUIPEMENT_PAR_TYPE = "/commerciale/equipement/rechercher-liste-equipements";
export const UPDATE_EQUIP = "/commerciale/equipement/modifier";
export const ADD_EQUIP = "/commerciale/equipement/enregistrer";
export const DELETE_EQUIP = "/commerciale/equipement/supprimer";
/////////////////////////////////////////////////////////////////

///////////////////Forfait////////////////////////////////////////
export const LIST_FORFAIT = "/commerciale/forfait/rechercherforfaits";
export const DELETE_FORFAIT = "/commerciale/forfait/supprimer";
export const ADD_FORFAIT = "/commerciale/forfait/enregistrer";
export const UPDATE_FORFAIT = "/commerciale/forfait/modifier";
export const FORFAIT_PAR_EQUIPE = "/commerciale/forfait/rechercherforfaitparequipement"
export const RECUPERER_FORFAIT = "/commerciale/abonnement/rechercher-abonnement-par-numeroticket"
/////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////
export const LIST_POINT_SERVICE = "/commericiale/pointservice/rechercher-point-service";
export const DELETE_POINT_SERVICE = "/commerciale/pointservice/supprimer";
export const ADD_POINT_SERVICE = "/commerciale/pointservice/enregistrer";
export const CHARGER_POINT_SERVICE_PAR_LOT = "commerciale/pointservice/enregistrer-par-lot";
export const POINT_SERVICE = "/commericiale/pointservice/rechercher-liste"
export const POINT_SERVICE_USER = '/commerciale/pointservice/rechercher-point-service-user'
/////////////////////////////////////////////////////////////



//////////////////////Intention////////////////////////////////
export const LIST_INTENTION = "/commerciale/abonnement/rechercherabonnements";
export const ADD_INTENTION = "/commerciale/abonnement/enregistrer";
export const RENDEZ_VOUS = "/commerciale/rendezvous/enregistrer";
export const CONFIRME_INTENTION = "/commerciale/abonnement/confirmerintention";
export const EDIT_ABONNEMENT = "/commerciale/abonnement/modifier";

// Suppression / ventes supprimées
export const DEMANDER_SUPPRESSION = "/commerciale/abonnement/v3/{id}/demander-suppression";
export const VALIDER_SUPPRESSION = "/commerciale/abonnement/v3/{id}/valider-suppression";
export const RECHERCHER_VENTE_SUPPRESSION = "/commerciale/abonnement/v3/rechercher-vente-supprimer";
export const RECHERCHER_VENTE_ATTENTE_SUPPRIMER = "/commerciale/abonnement/v3/rechercher-vente-attente-validation-suppression";
export const RECHERCHER_VENTE_SUPPRESSION_REJETES = "/commerciale/abonnement/v3/rechercher-vente-suppression-rejetes";
export const VERIFIER_VENTES_ENCOURS = "/commerciale/abonnement/verifier-ventes-encours";
/////////////////////////////////////////////////////////////


//////////////////Livraison///////////////////////////////////
export const LIST_LIVRAISON = "/commerciale/livraison/rechercher-livraisons";
export const ADD_LIVRAISON = "/commerciale/livraison/enregistrer";
export const GENERATE_CODE_LIVRAISON = "/commerciale/eligibilite/generer-otp";
export const BORDEREAU_LIVRAISON = "commerciale/livraison/telechargerbroderau";
export const MODIFIER_LIVRAISON = "/commerciale/modifiernumeroftth";
////////////////////////////////////////////////////////////


///////////////////Paiement////////////////////////////////
export const LIST_PAIEMENT = "/commerciale/paiement/rechercherpaiements";
export const ADD_PAIEMENT = "/commerciale/paiement/enregistrerpaiement";
export const VERFIF_PAIEMENT = "/commerciale/paiement/verifierstatutpaiement";
export const CHECK_IS_FREE = "/commerciale/paiement/rechercherpaiementfree";
export const CHARGER_FICHIER = "/commerciale/paiement/chargerrecupaiement";
export const TELECHARGEMENT_RECU = "commerciale/paiement/telechargerrecupaiement";
///////////////////////////////////////////////////////////////////////


///////////////////////////RENDEZ-VOUS///////////////////////////////
export const MODIFIER_RENDEZ_VOUS = "/commerciale/rendezvous/modifier";
export const LIST_RDV = "/commerciale/rendezvous/rechercherrendezvous";
export const RENDEZ_VOUS_PAR_STATUS = "/commerciale/rendezvous/rechercherrendezvousparstatusabonnement";
///////////////////////////////////////////////////////////////////////////////


//////////////////////////////RACCORDEMENT///////////////////////////
export const LIST_RACCORDEMENT = "/commerciale/raccordement/rechercher-raccordements";
export const DETAIL_RACCORDEMENT = "/commerciale/raccordment/rechercherDetails";
export const UPDATE_RACCORDEMENT = "/commerciale/raccordement/modifier";
////////////////////////////////////////////////////////////////////////////////


///////////////////////////////SURVEY/////////////////////////////////
export const LIST_SURVEY = "/commerciale/survey/rechercher-surveys";
export const UPDATE_SURVEY = "/commerciale/survey/modifier";
export const SURVEY_PAR_TYPE = "/commerciale/rendezvous/rechercherrendezvouspartyperdv";
export const TYPE_RENDEZ_VOUS = "/commerciale/rendezvous/rechercher-rdv-par-typerdv-par-statutabonnement"
/////////////////////////////////////////////////////////////////////////////////////////


////////////////////////////SOUSCRIPTION//////////////////////////////
export const SOUSCRIPTION = "/commerciale/souscription/enregistrer";
export const RECUPERE_SOUSCRIPTION = "/commerciale/souscription/recuperersouscription";
export const LIST_SOUSCRIPTION = "/commerciale/souscription/rechercher-souscriptions";
export const VERFIF_SOUSCRIPTION = "/commerciale/souscription/recherchercategoriesosucription"
export const SOUSCRIRE = "/commericiale/souscription/souscrire"
export const EN_ATTENTE_SOUSCRIPTION = "/commerciale/souscription/rechercher-souscriptions-en-attente";
// export const VERFIF_SOUSCRIPTION = "/commerciale/souscription/recherchercategoriesosucription"
/////////////////////////////////////////////////////////////////////////////////


////////////////////////////////TEST/////////////////////////////////////
export const TEST_SOUSCRIPTION = "/commerciale/test/enregistrer";
export const LIST_TEST = "/commerciale/test/rechercher-tests";
export const EN_ATTENTE_TEST = "/commerciale/test/rechercher-test-en-attente";
///////////////////////////////////////////////////////////////////////////


/////////////////////////////////////ACTIVATION////////////////////////////////
export const ACTIVATION = "/commerciale/activation/enregistrer";
export const LIST_ACTIVATION = "/commerciale/activation/rechercher-activations";
////////////////////////////////////////////////////////////////////////////
export const VALIDATION_VENTE = "/commericiale/abonnement/valider-vente-par-sp"

///////////////////Zone//////////////////////////////////////////////
export const RECUPERER_ZONE_COUVERTURE = "/commerciale/zonecouverture/rechercherfichier";
export const RECUPERER_ZONE_COVERTURE_FICHIER = "/commerciale/zonecouverture/rechercherzone";
export const ADD_ZONE_COUVERTURE = "/commerciale/zonecouverture/enregistrer";
export const ZONE_COUVERTURE = "/commerciale/fichier/chargerfichier";
//////////////////////////////////////////////////////////////////////////


///////////////////Tableau de board////////////////////////////////
export const RECUPERER_DATA_COUNTER = "/commerciale/abonnement/rechercherstatsdashboard";
export const RECUPERE_GRAPHE_CHIFFRE_AFFAIRE = "/commerciale/paiement/recherchergraphechiffreaffaire";
export const RECUPERE_GRAPHE_INSTALLATION = "/commerciale/abonnement/recherchergraphetotalabonnement";
//////////////////////////////////////////////////////////


////////////////////////////////STATISTIQUE///////////////////////////////
export const COURBE = "/commerciale/abonnement/recherchergrapheglobal";
export const STATS_COUNTER_SURVEY = "/commerciale/rendezvous/rechercherstatsrendezvous";
//////////////////////////////////////////////////////////////////////////


///////////////////////////////////EQUIPE/////////////////////////////
export const ADD_TEAM = "/commerciale/equipe/enregistrer";
export const ENREGISTRER_TEAM = "/commerciale/equipe/attribuer-equipe-techniciens"
export const LIST_TEAM = "/commerciale/equipe/rechercherequipes";
export const DELETE_AGENT_BY_TEAM = "/commerciale/equipe/retirertechnicien/";
export const EQUIPE_DISPO = "/commerciale/equipe/rechercherequipesdispo";
export const LISTE_EQUIPE_SANS = "/commerciale/equipe/recherchertechniciensansequipe";
export const TECHNICIEN_PAR_EQUIPE = "/commerciale/equipe/recherchertechnienparequipe";
export const DISABLE_TEAM = "/commerciale/equipe/desactiver";
export const EDIT_TEAM = "/commerciale/equipe/modifier";
export const RETIRER_TECHNICIEN = "/commerciale/equipe/retirertechnicien";
///////////////////////////////////////////////////////////////////////////////////////


//////////////////////COMMENTAIRE///////////////////////////////////////////////
export const LIST_COMMENTAIRE = "/commerciale/typecommentaire/recherchertypescommentaire";
export const ADD_COMMENTAIRE = "/commerciale/typecommentaire/enregistrer";
export const DELETE_COMMENTAIRE = "/commerciale/typecommentaire/supprimer";
export const UPDATE_COMMENTAIRE = "/commerciale/typecommentaire/modifier";
//////////////////////////////////////////////////////////////////////////////////////


////////////////////////////////////////////OPERATION///////////////////////////
export const TOTAL_OPS = "/commerciale/totaleoperation/enregistrer";
export const GET_TOTAL_OPS = "/commerciale/totaleoperation/recherchertotaloperationparjour";
////////////////////////////////////////////////////////////////////////////////////////


////////////////////////ELIGIBILITE/////////////////////////////
export const LIST_ELIGIBILITE = "/commerciale/eligibilte/recherchereligibilites";
export const VERIFICATION_ELIGIBILITE = "/webfree/eligibilite/verifier";
export const VERIFICATION_PAR_LOT = "/commerciale/eligibilite/verifierlisteligibilites";
///////////////////////////////////////////////////////////////////////


////////////////////////////////MENU ET PERMISSION//////////////////////////
export const LIST_MENU = "/commerciale/rolepermission/rechercherlistmenus";
export const ADD_PERM = "/commerciale/permission/enregistrer";
export const RECHERCHER_PERM = "/commerciale/rolepermission/rechercherlistactionsparrole";
/////////////////////////////////////////////////////////////////////////////////


///////////////////////////PBO///////////////////
export const LIST_PBO = "/commerciale/pbo/rechercherpbos";
export const ADD_PBO = "/commerciale/pbo/enregistrer ";
export const UPDATE_PBO = "/commerciale/pbo/modifier"
export const DELETE_PBO = "commerciale/pbo/supprimer";
export const CHARGER_FICHIER_PBO = "/commerciale/pbo/enregistrerparlot";
export const CHARGER_LISTE_PBO = "/commerciale/abonnement/charger-ficher-pbo"
export const PBO_DISPO = "/commerciale/pbo/rechercherpbodispo"
export const DISTANCE_PBO_ADD = "/commericiale/pbo/enregistrerdistance"
export const DISTANCE_PBO = "/commericiale/pbo/rechercherdistance"
export const COUPLEUR_PAR_PBO = "/commerciale/coupleur/recherchercoupleurs"
//////////////////////////////////////////////////////////////////////


////////////////////////////ZONE DE COUVERTURE///////////////
export const FICHIER_ZONE_COUVERTURE = "/commerciale/zonecouverture/rechercherzone";
/////////////////////////////////////////////////////////////////////////////


/////////////////////////BRIN//////////////////////////////
export const PBO_LIST_BRIN = "/commerciale/brin/rechercherbrinsparpbo";
export const ADD_BRIN = "/commerciale/brin/enregistrer";
export const UPDATE_BRIN = "/commerciale/brin/modifierstatus";
export const DELETE_BRIN = "/commerciale/brin/supprimer";
export const EDIT_BRIN = "/commerciale/brin/modifier";
//////////////////////////////////////////////////////////////////////


/////////////////////////COUPLEUR//////////////////////////////
export const ADD_COUPLEUR = "/commerciale/coupleur/enregistrer";
export const UPDATE_COUPLEUR = "";
export const DELETE_COUPLEUR = "";
//////////////////////////////////////////////////////////////////////

/////////////////////////////////////ROLE///////////////////////
export const LISTE_ROLE = "/commerciale/role/rechercherlistroles";
export const ROLE = "/commerciale/role/rechercher-liste-roles"
export const ADD_ROLE = "/commerciale/role/enregistrer";
export const DELETE_ROLE = "/commerciale/role/supprimer";
export const EDIT_ROLE = "/commerciale/role/modifierrole"
///////////////////////////////////////////////////////////////////


////////////////////////PLANIFICATION///////////////////////////////
export const DELETE_PLANING = "/commerciale/planning/supprimer";
export const LIST_PLANING = "/commerciale/planning/rechercherplannings";
export const EDIT_PLANING = "/commerciale/planning/modifier";
export const FAIRE_PLANING = "/commerciale/planning/enregsitrer-2";
export const DATE_DISPO = "/commerciale/planning/rechercher-dates-dispo";
export const DATE_DISPO_SURVEY = "/commerciale/planning/rechercherdatesdispo-survey"
export const DATE_DISPO_RACCORDEMENT = "/commerciale/planning/rechercherdatesdispo-raccordement?numeroTicket="
////////////////////////////////////////////////////////////////////


//////////////////////////////SLA/////////////////////////////////////
export const SLA_INDICATOR_LIST = "/commericiale/sla/rechercher-liste-slas"
export const UPDATE_INDICATOR_SLA = "/commerciale/sla/enregistrer"

////////////////////////////FICHIER/////////////////////////////
export const FICHIER_DOWNLOAD = "commerciale/fichier/telechargerfichier"
export const FICHIER_ABONNEMENT = "/commerciale/abonnement/charger-ficher-abonnements"
///////////////////////////RAPPORT////////////////////////////////
export const EXPORT_RAPPORT = "commerciale/abonnement/export-to-excel"
export const EXPORT_PROVISIONING_EN_ATTENTE = "commerciale/provioning-en-attente/export-to-excel"

//////////////////////////////////PROVISIONING////////////////////////
export const LISTE_PROVISIONING = "/commerciale/provisioning/rechercherprovisioning"
export const UPDATE_PROVISIONING = "/commerciale/provisionning/enregistrer"

export const LISTE_COMMUNE = "/commerciale/prestataire-commune/v3/communes-non-associes"
export const LISTE_COMMUNE_PRESTATAIRE = "/commerciale/prestataire-commune/v3/communes-par-prestataire"
export const AJOUTER_PRESTATAIRE = "/commerciale/prestataire-commune/v3/enregistrer"
export const ACTIVER_DESACTIVER_PRESTATAIRE = "/commerciale/prestataire/desactiver"
export const LISTE_PRESTATAIRE = "/commerciale/prestataire/rechercher-prestataires"
export const PRESTATAIRE = "/commerciale/prestataire/rechercher-list-prestataires"
export const RETIRER_COMMUNE_PRESTATAIRE = "/commerciale/prestataire-commune/v3/dissocier"
export const LISTE_EQUIPE_PRESTATAIRE = "/commerciale/equipe/rechercher-liste-equipe-associer"
export const LISTE_EQUIPE_TECH = "/commerciale/equipe/rechercher-liste-equipe-associer-technicien"
export const LISTE_EQUIPE_DISPO_PRESTATAIRE = "/commericiale/planning/rechercher-liste-equipe-dispo-prestataire"
export const LISTE_COMMUNE_SANS_PAGINATION = "/commerciale/commune/rechercher-liste-commune"
export const CHARGER_FICHIER_PROVISIONING = "/commerciale/provisionning/enregistrerparlot"
export const AJOUTER_QUARTIER_COMMUNE = "/commerciale/quartier/enregistrer"
export const LISTE_COMMUNE_PAR_PAGE = "/commerciale/commune/rechercher-communes"
export const MODIFIER_ETAT_COMMUNE = "/commerciale/commune/modifier-etat"
export const CHARGER_FICHIER_COMMUNE = "/commerciale/commune/modifier-designation-commune-liste-excel"
export const QUARTIER_COMMUNE = "/commerciale/quartier/rechercher-quartiers"
export const LISTE_QUARTIER_PAR_COMMUNE = "/commerciale/quartier/rechercher-liste-quartier-par-ccommune"
export const LISTE_PARAMETRE_CONFIG = "/commerciale/parametre/rechercher-liste-parametre"
export const AJOUTER_PARAMETRE = "/commericiale/parametre/enregistrer"
export const LISTE_SLA = "/commericiale/sla/rechercher-liste-slas"
export const PERFORMANCE_PAR_COMMUNE = "/commerciale/abonnement/rechercher-stats-par-commune"
export const TOTAL_CONNECTION = "/commerciale/test/rechercher-total-connection-delai"
export const PROSPECT_LISTE = "/commerciale/abonnement/rechercher-prospects"
export const AJOUTER_COMMUNE = "/commerciale/commune/enregistrer"


export const EN_ATTENTE_PAIEMENT = "/commerciale/paiement/rechercherpaiements-en-attente"
export const EN_ATTENTE_LIVRAISON = "/commerciale/livraison/rechercher-livraisons-en-attente"
export const EN_ATTENTE_RENDEZ_VOUS = "/commerciale/rendezvous/rechercher-en-attente-de-prise-rendezvous"
export const EN_ATTENTE_ACTIVATION = "/commerciale/activation/rechercher-activations-en-attente"
export const EN_ATTENTE_IDENTIFICATION = "/commerciale/identification/rechercher-identifications-en-attente"
export const EN_ATTENTE_INSTALLATION = "/commerciale/installation/rechercher-installations-en-attente"
export const LISTE_ABONNEMENT_VALIDATION_SP = "/commerciale/abonnnement/rechercher-abonnement-valider-sp"

export const DELETE_SERVICE_PARTNER = '/commericiale/servicepartner/supprimer'
export const SERVICE_PARTNER_LISTE = '/commericiale/servicepartner/rechercher-liste-servicepartner'
export const SERVICE_PARTNER = "/commericiale/servicepartner/rechercher-user-servicepartner"
export const RECHERCHER_SERVICE_PARTNER = '/commericiale/servicepartner/rechercher-servicepartners'
export const AJOUTER_SERVICE_PARTNER = '/commericiale/servicepartner/enregistrer'
export const CHARGER_LISTE_SERVICE_PARTNER = '/commerciale/servicepartner/enregistrerparlot'
export const RAPPORT_PAIEMENT = "commerciale/abonnement/export-to-excel"

export const REFRESH_TOKEN = "webfree/refresh-token?token="
export const ERROR_MESSAGE_TOKEN_EXPIRE = "Cannot invoke \"com.skan.mtnftthapi.security.UserPrincipal.getId()\" because \"currentUser\" is null"

export const LISTE_NUMERO_FTTH = "/commerciale/numerosffth/rechercher-numerosftth"
export const ENREGISTRER_NUMERO_FFTH = "/commerciale/numerosffth/enregistrer"
export const IMPORTER_NUMERO_FTTH = "/commerciale/numerosffth-modifier-statut-par-lot"
export const EXPORTER_NUMERO_FTTH = "commerciale/numerosffth/export-to-excel-numeros-par-statut"
export const MODIFICATION_NUMERO_FTTH = "commerciale/numerosffth/modifier-status"
export const SUPPRIMER_NUMERO_FTTH = "commercial/numerosftth/supprimer"
export const CREATE_USER_ACOUNT = "/webfree/client/enregistrer"

export const LISTE_LOGS = "/commericiale/logs/rechercherlogs"
export const EXPORT_LOGS = "commerciale/log/export-to-excel"
export const AJOUTER_FAQ = "/commerciale/faq/enregsitrer"
export const LISTE_FAQ = "/commerciale/faq/rechercher-faq"
export const LISTE_UTILISATEUR_ROLE = "/commercial/user/rechercher-liste-utiliseurs-par-role"

export const RECHERCHER_ADRESS_CLIENT = "/commericiale/commune/rechercher-adresse-client"
// export const LISTE_SUPERVISEUR_COMMERCIAL = "/commercial/user/rechercher-liste-superviseurcommercial"

export const RECHERCHER_NUMERO_FTTH = '/commercial/livraison/rechercher-numeroftth-par-abonnement'
export const CHARGER_LISTE_UTILISATEUR = '/commercial/user/enregistrer-par-lot'
export const LISTE_OPERATEUR = '/commerciale/modepaiement/rechercher-liste'
export const MODE_PAIMENTS_ENREGISTRER = '/commerciale/modepaiement/enregistrerparlot'
export const SUPPRIMER_MODE_PAIEMENT = "/commerciale/modepaiement/supprimer-par-id"
export const MODE_PAIEMENTS = "/commerciale/modepaiement/rechercher-modepaiements"
export const CHANGER_ETAT_MODE_PAIEMENT = "/commerciale/modepaiement/modifier-etat"
export const REACTIVATION_USER = '/commercial/user/reactiver-compte'
export const RECHERCHER_SUPERVISEUR_COMMERCIALE = "/commercial/user/rechercher-superviseurcommercials"
export const COURBE_VENTE_PAR_HEURE = '/commerciale/rechercher-graphe-total-vente-par-heure'
export const STATUS_BRIN_PAR_ZONE = '/commerciale/brin/rechercher-stats-brins-par-commune'
export const TOP_10_AGENT = '/commerciale/rendezvous/rechercher-top10-agent-vente-jour'
export const TOP_10_TECHNICIEN = "/commerciale/test/rechercher-top10-equipes-vente-jour"
export const TOP_10_AGENT_MOINS_PERF = "/commerciale/abonnement/rechercher-top10-agent-moins-performants"
export const TOP_10_TECHNICIEN_MOINS_PERF = "/commerciale/rendezvous/rechercher-top10-equipes-moins-performants"
export const LISTE_AGENCE = '/commerciale/agence/rechercher-agences'
export const LISTE_AGENCE_SANS_PAGINATION = "/commericale/agence/rechercher-liste-agences"
export const DELETE_AGENCE = "/commerciale/agence/supprimer"
export const AJOUTER_AGENCE = "/commerciale/agence/enregistrer"
export const UTILISATEUR_PAR_ROLE_PARENT = '/commericiale/user/rechercher-utilisateurs-parent'
export const SHOW_PASSWORD = '/commerciale/abonnement/visualiser-mdp-activation'
export const REST_ACCOUNT = "/commercial/user/reset-compte"
export const RETIER_EQUIPE = "/commerciale/commune/retirer-equipe-prestataire"
export const SUPPRIMER_EQUIPE = "/commerciale/equipe/v3/supprimer"
export const ASSOCIER_EQUIPE_PRESTATAIRE = "/commerciale/equipe/associer-equipe-prestataire"
export const DESASSOCIER_EQUIPE_PRESTATAIRE = "/commerciale/commune/retirer-equipe-prestataire"
export const LISTE_EQUIPE_NON_ASSOCIEE = "/commerciale/equipe/rechercher-liste-equipe-non-associer"
export const ACTUALISER_POSITION = "/commerciale/abonnement/normaliser-geolocalisation-abonnement?numeroTicket="
export const RENDEZ_VOUS_EN_ATTENTE_ATTRIBUTION = "/commerciale/rdv-corbeille/rechercher-rdv-en-attente-attribution"
export const RENDEZ_VOUS_EN_ATTENTE_ATTRIBUER_PAR_EQUIPE = "/commerciale/rdv-corbeille/v3/rechercher-rdv-en-attente-attribution-equipe"
export const ATTRIBUTION_RDV_CORBEILLE_PRESTATAIRE = "/commerciale/rdv-corbeille/v3/prestataire"
export const ATTRIBUTION_RDV_EQUIPE = "/commerciale/rdv-corbeille/v3/rechercher-rdv-attribuer-equipe"
export const RENDEZ_VOUS_EN_ATTENTE_ATTRIBUTION_PRESTATAIRE = "/commerciale/rdv-corbeille/v3/rechercher-rdv-en-attente-attribution-equipe"
export const RENDEZ_VOUS_ATTRIBUER_EQUIPE = "/commerciale/rdv-corbeille/v3/rechercher-rdv-attribuer-equipe"
export const ASSOSCIER_COORDO_PRESTATAIRE = "/commercial/coordinateur-prestataire/v3/associer-liste"
export const LISTE_COORDO_PRESTATAIRE = "/commercial/coordinateur-prestataire/v3/prestataire"
export const LISTE_EQUIPE_COORDO = "/commerciale/equipe/v3/rechercher-equipe-coordinateur"
export const LISTE_NON_ASSOSCIER_COORDO_EQUIPE = "/commerciale/equipe/v3/rechercher-equipes-non-associes-coordinateur/"
export const ASSOCIER_COORDO_EQUIPE = "/commerciale/equipe/associer-equipe-coordinateur"
export const EQUIPE_COORDO = "/commerciale/equipe/v3/liste-equipe-associee-coordinateur"
export const EQUIPE_COORDINATEUR_ATTRIBUTION = "/commerciale/equipe/v3/liste-equipe-associee-coordinateur"
export const LISTE_PBO_DISPO = "/commerciale/pbo/rechercher-liste-pbo-disponible"
export const LISTE_BRIN_DISPO = "/commerciale/brin/rechercher-liste-brin-libre-par-pbo"
export const EDIT_INTENTION_PBO = "/commerciale/brin/modifier-pbo"
export const EXPORT_EXCEL_RDV_ATTENTE_ATTRIBUTION = "/commerciale/rdv-corbeille/v3/export-to-excel-vente-en-attente-attribution";
export const EXPORT_EXCEL_RDV_ATTRIBUE_EQUIPE = "/commerciale/rdv-corbeille/v3/export-to-excel-vente-en-attente-attribution-equipe";
export const ATTRIBUTION_PRESTATAIRE_PAR_LOT = "/commerciale/rdv-corbeille/v3/attribution-a-prestataire-par-lot";
export const SUPPRESSION_VENTE_BATCH = "/commerciale/abonnement/valider-supprersession-vente-par-lot"
export const CHANGER_STATUT_ABONNEMENT_RETOURNEE = "/commerciale/retour-abonnements/modifier-statut"
// Maintenance Endpoints
export const ENREGISTRER_MAINTENANCE = "/commercial/maintenance/enregistrer";
export const RECHERCHER_MAINTENANCES = "commercial/maintenance/rechercher-maintenances";
export const MODIFIER_STATUT_MAINTENANCE = "/commercial/maintenance/modifier-statut";
export const EXPORTER_LISTE_BRIN = "/commerciale/brins/export-to-excel-par-statut"
// Priorite Enum
export const PRIORITE = {
    CRITIQUE: "CRITIQUE",
    HAUTE: "HAUTE",
    MOYENNE: "MOYENNE",
    BASSE: "BASSE",
};
export const RETIRER_DOSSIER_PRESTATAIRE = "/commerciale/rdv-corbeille/v3/retirer-attribution-prestataire-par-lot"
export const RECHERCHER_ABONNEMENT_RETOURNEE = "/commerciale/retour-abonnements/rechercher"
export const LISTE_MAINTENANCE = "/commercial/maintenance/rechercher-maintenances";
export const LISTE_EN_ATTENTE_MAINTENANCE_PRESTATAIRE = "/commercial/maintenance/rechercher-maintenances-attente-attribution-prestataire";
export const LISTE_ATTRIBUE_MAINTENANCE_PRESTATAIRE = "/commercial/maintenance/rechercher-maintenances-attribuer-prestataire";
export const LISTE_ATTRIBUE_EQUIPE_MAINTENANCE = "/commercial/maintenance/rechercher-maintenances-attribuer-equipe";
export const LISTE_EN_ATTENTE_MAINTENANCE_EQUIPE = "/commercial/maintenance/rechercher-maintenances-en-attente-attribution-equipe";
export const RETIRER_MAINTENANCE_PRESTATAIRE = "/commercial/maintenance/retirer-prestataire";
export const RETIRER_MAINTENANCE_EQUIPE = "/commercial/maintenance/retirer-equipe";
export const ATTRIBUER_MAINTENANCE_PRESTATAIRE = "/commercial/maintenance/attribuer-prestataire/";
export const ATTRIBUER_MAINTENANCE_EQUIPE = "/commercial/maintenance/attribuer-equipe/";
export const EXPORT_EXCEL_MAINTENANCE = "/commerciale/maintenance/v3/export-to-excel-maintenance-en-attente-attribution-prestataire";
export const ATTRIBUTION_MAINTENANCE_LOT_EQUIPE = "/commerciale/maintenance/v3/attribution-a-equipe-par-lot";
export const ATTRIBUTION_MAINTENANCE_LOT_PRESTATAIRE = "/commerciale/maintenance/v3/attribution-a-prestataire-par-lot";
export const GENERER_QR_CODE = "commerciale/user/telechargerpointventeqrcode"
export const LISTE_POSTPAID = "/commerciale/abonnement/rechercher-abonnement-postpaid"
export const MODIFIER_POSTPAID = "/commerciale/abonnement/modifier-documents-abonnement-postpaid"
export const MODIFIER_STATUS_POSTPAID = "/commerciale/abonnement/modifier-statut-abonnement-postpaid"
export const DEGELER_POSTPAID = "/commerciale/rendezvous/degeler-rendezvous"
export const LISTE_PARTENAIRE_PAR_ABONNEMENT = "/commerciale/prestataire/rechercher-list-prestataires-postpaid"